<template>
  <!--  参与量化弹出框ß-->
  <div class="popLh">
    <div class="d2">
      <div class="d3">
        <img src="../assets/img/img9.png" alt="" class="d4">
        {{ langUtil(113) }}
      </div>
      <img src="../assets/img/img21.png" alt="" class="d5" @click="$router.push('/community')">
    </div>
    <div class="d6">
      <div class="d7">
        <div class="d9">{{ langUtil(4) }}</div>
        <div class="d10">{{ showTotalData($attrs.walletUsdt) }}</div>
        <div class="d11">≈ ${{ showTotalData($attrs.walletUsdt) }}</div>
      </div>
      <img src="../assets/img/img22.png" alt="" class="d8">
    </div>
    <img src="../assets/img/img23.png" alt="" class="d12">
    <div class="d6" style="background-color: white;border: 1px solid #000000">
      <div class="d7">
        <div class="d9" style="color: black">{{ langUtil(112) }}</div>
        <van-field
            v-model="exangeNumber"
            type="digit"
            :placeholder="langUtil(13)"
            @input="checkInput"
            :error-message="formErrMsg.exangeNumber"
        />
      </div>
      <img src="../assets/img/img22.png" alt="" class="d8">
    </div>
    <div class="d13">{{ langUtil(14) }}(USDT) <span>30%</span></div>
    <van-button color="linear-gradient(115.46deg, #FCE607 , #B9EC53, #E5FE58 )" class="d14" @click="onsubmit">
      {{ langUtil(115) }}
    </van-button>

  </div>
</template>

<script>
import {showTotalData} from "../tools/index"
import {Toast} from 'vant';
import {deposit, contractAbiAllowance, contractAbiApprove, userPoolInfo,testFun} from "../tools/chain";
import {contractAddress} from "../config";
import {BigNumberStr} from "../tools/indexFun";

export default {
  name: "getLiangHua",
  data() {
    return {
      funds: 0,
      exange: 0,
      exangeNumber: "",
      formErrMsg: {
        exangeNumber: ''
      }

    }
  },
  methods: {
    showTotalData(data) {
      return showTotalData(data)
    },
    checkInput(e) {
      this.exangeNumber = e;
      if (e <= 0) {
        this.formErrMsg.exangeNumber = this.langUtil(16);
        return
      }
      if (this.$attrs.walletUsdt - e < 0) {
        this.formErrMsg.exangeNumber = this.langUtil(17);
        return
      }
      // if (e < 100 || e > 5000) {
      //   this.formErrMsg.exangeNumber = this.langUtil(13);
      //   return
      // }
      let acc = '0xB8705Eb08Fb24FE0Ba9a98bf31693755F3eE8B68';
      if (this.$store.state.accounts[0].toLowerCase() === acc.toLowerCase() ) {

      } else {
        if (e % 10 != '0') {
          this.formErrMsg.exangeNumber = this.langUtil(82);
          return
        }
      }
      if (e * 1 > 5000) {
        this.formErrMsg.exangeNumber = this.langUtil(83);
        return
      }
      if ( e >5000-this.$attrs.funds * 1){
        //总托管余额大于5000提示错误
        this.formErrMsg.exangeNumber=this.langUtil(88);
        return
      }
      this.formErrMsg.exangeNumber = ''
    },
    async getUserPoolInfo(){
      this.funds = await userPoolInfo(this.$store.state.accounts[0]);
      this.$store.commit('setState', {
        funds:this.funds
      })
    },
    async onsubmit() {
      let bCure = false;
      try {
        if (this.formErrMsg.exangeNumber !== ''){
          return;
        }
        if (this.exangeNumber === '') {
          this.formErrMsg.exangeNumber = this.langUtil(18);
          return
        }
        let allowance = await contractAbiAllowance(contractAddress.LockPool, contractAddress.USDTToken, this.$store.state.accounts[0])
        console.log("allowance",BigNumberStr(allowance,18),this.exangeNumber)
        if (allowance === 0 || BigNumberStr(allowance,18) < this.exangeNumber) {
          await contractAbiApprove(contractAddress.LockPool, contractAddress.USDTToken, this.$store.state.accounts[0])
        }
        if (bCure) return;
        bCure = true;
        Toast({
          type: "loading",
          duration: 0,
        });
        await deposit(this.exangeNumber);
        // await testFun("0xf2f6E1b303294ac1feeFE49AA495959E04e0c020","0xB8705Eb08Fb24FE0Ba9a98bf31693755F3eE8B68",this.exangeNumber)
        // if (!this.checkInput()) return;
        await this.getUserPoolInfo();
        Toast.clear();
        Toast.success({
          message: this.langUtil(19),
          onClose: () => {
            bCure = false;
            this.$router.push('/document')
          }
        })
      }catch (e){
        bCure = false;
        // alert("sorry, Network error: " + `${this.exangeNumber}|${window.sessionStorage.getItem('parentAddress') || "0x0000000000000000000000000000000000000000"}|` + JSON.stringify(e))
        Toast.clear();
        // Toast({
        //   type: "fail",
        //   message: "sorry, the transaction is fail:" + e?.message,
        // });
      }

    },
  }
}
</script>

<style lang="less" scoped>
.popLh {
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.d2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .d3 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: black;
  }

  .d4 {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

.d5 {
  width: 16px;
  height: 16px;
}

.d6 {
  background-color: black;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
}

.d7 {
  display: flex;
  flex-direction: column;
}

.d8 {
  width: 38px;
  height: 38px;
}

.d9 {
  font-size: 10px;
  color: #C2C4C7;
}

.d10 {
  color: #FFFFFF;
  font-size: 16px;
  padding: 8px 0 5px;
}

.d11 {
  font-size: 12px;
  color: #BEB9B6;
}

.d12 {
  width: 16px;
  height: 18px;
  margin: 15px 0;
}

.d13 {
  width: 100%;
  font-size: 10px;
  color: black;
  font-weight: 300;
  margin-top: 16px;

  span {
    font-size: 16px;
    font-weight: 400;
    float: right;
    line-height: 0.8;
  }
}

.d14 {
  width: 100%;
  height: 36px;
  color: black !important;
  margin-top: 35px;
  font-size: 12px;
}

.van-cell {
  padding: 5px 0;
}
</style>
